import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import Swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: 'app-topbar-partial',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, NgxLoadingModule],
  templateUrl: './topbar-partial.component.html',
  styleUrls: ['./topbar-partial.component.scss'],
})
export class TopbarPartialComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public user: any = null;
  statusNotifications: boolean = false;
  arrayCount: any[] = [];
  search: string = '';
  public sidebarProgress: boolean = false;
  @Output() notifications = new EventEmitter<boolean>();

  constructor(private _api: ApiService, private _router: Router) {
    console.log('TopbarPartialComponent constructor');
  }

  async ngOnInit(): Promise<void> {
    console.log('TopbarPartialComponent ngOnInit');

    this._api.userObservable.subscribe({
      next: (user: any) => {
        console.log('TopbarPartialComponent userObservable user', user);
        this.user = user;
      },
      error: (error: any) => {
        console.log('TopbarPartialComponent userObservable error', error);
        this.user = null;
      },
    });

    this.handleMobileSidebarToggle();
  }

  ngOnDestroy(): void {
    console.log('TopbarPartialComponent ngOnDestroy');
  }

  public logout(): void {
    console.log('TopbarPartialComponent logout');

    this.loading = true;

    this._api.post('api/sanctum/logout', {}).subscribe({
      next: (response: any) => {
        console.log('TopbarPartialComponent logout response', response);

        localStorage.removeItem('token');

        this._router.navigate(['/']).then(() => {
          this.loading = false;

          window.location.href = window.location.href;
        });
      },
      error: (error: any) => {
        console.log('TopbarPartialComponent logout error', error);

        this.loading = false;

        localStorage.removeItem('token');
      },
    });
  }

  toggleShowTransicion(): void {
    this.notifications.emit(
      (this.statusNotifications = !this.statusNotifications)
    );
    this.statusNotifications = !this.statusNotifications;
    this.arrayCount = [];
  }

  changeSearch() {
    let arraySearch: string[] = [];
    arraySearch.push(this.search);
    // this._search.setSearch(arraySearch);
  }

  public handleMobileSidebarToggle(): void {
    let sidebarProgress = false;

    $(document).on('click touchstart', '.sidebar', (e: any) => {
      if ($(e.target).closest('.sidebar').length !== 0) {
        sidebarProgress = true;
      } else {
        sidebarProgress = false;
        e.stopPropagation();
      }
    });

    $(document).on('click touchstart', (e: any) => {
      if ($(e.target).closest('.sidebar').length === 0) {
        sidebarProgress = false;
      }
      if ($(e.target).closest('#float-sub-menu').length !== 0) {
        sidebarProgress = true;
      }

      if (!e.isPropagationStopped() && sidebarProgress !== true) {
        if ($('#page-container').hasClass('page-sidebar-toggled')) {
          sidebarProgress = true;
          $('#page-container').removeClass('page-sidebar-toggled');
        }
        if ($(window).width() <= 767) {
          if ($('#page-container').hasClass('page-right-sidebar-toggled')) {
            sidebarProgress = true;
            $('#page-container').removeClass('page-right-sidebar-toggled');
          }
        }
      }
    });

    $(document).on('click', '[data-click=right-sidebar-toggled]', (e: any) => {
      e.stopPropagation();
      let targetContainer = '#page-container';
      let targetClass = 'page-right-sidebar-collapsed';
      targetClass =
        $(window).width() < 768 ? 'page-right-sidebar-toggled' : targetClass;
      if ($(targetContainer).hasClass(targetClass)) {
        $(targetContainer).removeClass(targetClass);
      } else if (sidebarProgress !== true) {
        $(targetContainer).addClass(targetClass);
      } else {
        sidebarProgress = false;
      }
      if ($(window).width() < 480) {
        $('#page-container').removeClass('page-sidebar-toggled');
      }
      $(window).trigger('resize');
    });

    $(document).on('click', '[data-click=sidebar-toggled]', (e: any) => {
      e.stopPropagation();
      let sidebarClass = 'page-sidebar-toggled';
      let targetContainer = '#page-container';

      if ($(targetContainer).hasClass(sidebarClass)) {
        $(targetContainer).removeClass(sidebarClass);
      } else if (sidebarProgress !== true) {
        $(targetContainer).addClass(sidebarClass);
      } else {
        sidebarProgress = false;
      }
      if ($(window).width() < 480) {
        $('#page-container').removeClass('page-right-sidebar-toggled');
      }
    });
  }

  /*   toggleShowTransicion(){
    let targetContainer = '.noty-panel';
		let targetClass = 'active';
		var targetExpand = false;
		if ($(targetContainer).hasClass(targetClass)) {
			$(targetContainer).removeClass(targetClass);
		} else {
			$(targetContainer).addClass(targetClass);
			targetExpand = true;
		}
  } */
}
